import _isEmpty from 'lodash/isEmpty';
import { CREATED } from 'utils/constants/examinationStatuses';

export default (item) => {
  if (_isEmpty(item)) {
    return '';
  }
  return (item.is_remote && item.status === CREATED ? 'LINK' : item.status);
};
